import Toggle from '@resources/js/ui/Toggle'
import Emitter from '@resources/js/helpers/Emitter'

class Tab extends Toggle {
	constructor(...props) {
		super(...props)
	}

	toggle() {
		if (this.active) return
		super.toggle()
		this.emiter.emit('open', this)
	}
}

export default class Tabs extends Emitter {
	constructor(container) {
		super()
		this.container =
			container instanceof HTMLElement
				? container
				: document.querySelector(container)

		const tabs = [...this.container.querySelectorAll('[data-target]')]
		this.items = tabs.map(trigger => new Tab(trigger))
		this.items.forEach(trigger =>
			trigger.on('open', this.#hideOtherToggle.bind(this))
		)
	}

	openIndex(index) {
		const current = this.items[index]
		if (!current) throw new Error(`Element with index ${index} not found`)

		current.show()
		this.#hideOtherToggle(current)
	}

	getActiveTab() {
		return this.items.find(tab => tab.active)
	}

	#hideOtherToggle(activeTab) {
		this.items.forEach(tab => {
			if (tab !== activeTab) tab.hide()
		})

		this.emit('change', activeTab)
	}
}
